import Chart from 'chart.js';
import cloneDeep from 'lodash/cloneDeep';

const rootElements = Array.from(document.querySelectorAll('.js-performance'));

const CHART_OPTIONS = {
    maintainAspectRatio: false,
    responsive: true,
    events: false,
    tooltips: {
        enabled: false,
    },
    hover: {
        animationDuration: 0,
    },
    animation: {
        duration: 500,
        easing: 'easeOutQuart',
        onComplete: function handleComplete() {
            // render the value of the chart above the bar
            const chartInstance = this.chart;
            const ctx = chartInstance.ctx;
            ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
            ctx.fillStyle = 'white';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'bottom';

            this.data.datasets.forEach((dataset, i) => {
                const meta = chartInstance.controller.getDatasetMeta(i);
                meta.data.forEach((bar, index) => {
                    const value = dataset.data[index];
                    const displayString = value > 0 ? `+${value}%` : `${value}%`;
                    /* eslint-disable no-underscore-dangle */
                    if (value > 0 && (bar._model.base - bar._model.y < 20)) {
                        ctx.fillText(displayString, bar._model.x, bar._model.y - 6);
                    } else {
                        ctx.fillText(displayString, bar._model.x, value > 0 ? (bar._model.y + 20) : (bar._model.y + 20));
                    }
                });
            });
        },
    },
    legend: {
        display: false,
    },
    layout: {
        padding: {
            left: 0,
            right: 0,
            top: 40,
            bottom: 40,
        },
    },
    scales: {
        yAxes: [{
            ticks: {
                display: true,
                callback: value => `${value}%`,
                fontColor: 'rgba(255,255,255,0.6)',
                fontFamily: 'Camber W01',
                fontSize: 12,
                maxTicksLimit: 4,
                padding: 12,
                min: 0,
                suggestedMin: -10,    // minimum will be 0, unless there is a lower value.
                beginAtZero: true,

            },
            gridLines: {
                color: 'rgba(255,255,255,0.1)',
                zeroLineColor: 'rgba(255,255,255,0.1)',
                drawBorder: false,
            },
        }],
        xAxes: [{
            ticks: {
                display: true,
                fontColor: 'rgba(255,255,255,0.6)',
                fontFamily: 'Camber W01',
                fontSize: 12,
                padding: 12,
            },
            gridLines: {
                display: false,
            },
            barPercentage: 0.75,
        }],
    },
};

class Performance {
    constructor(root) {
        if (!root) return;

        this.chartMount = root.querySelector('.js-performance-chart');
        this.chartSelectors = Array.from(root.querySelectorAll('.js-chart-selector'));
        this.chartSelectorMobile = root.querySelector('.js-chart-selector-mobile');
        this.chartDescriptions = Array.from(root.querySelectorAll('.js-chart-description'));
        this.charts = JSON.parse(this.chartMount.dataset.charts);
        this.data = cloneDeep(this.charts[0]);

        // Init chart with configuration
        this.chart = new Chart(this.chartMount, {
            type: 'bar',
            data: this.data,
            options: CHART_OPTIONS,
        });

        this.addEventListeners();
    }

    changeChart(handle) {
        // Remove active state on all portfolio selector buttons
        this.chartSelectors.forEach(s => s.classList.remove('is-active'));

        // Remove active state from all portfolio descriptions
        this.chartDescriptions.forEach(d => d.classList.remove('is-active'));

        const newValues = cloneDeep(this.charts)
            .find(chart => chart.handle === handle);

        this.chart.data.datasets.pop();
        this.chart.data.datasets.push(...newValues.datasets);
        this.chart.update({
            duration: 500,
            easing: 'easeOutQuart',
        });
    }

    // Update description
    updateDescription(handle) {
        this.chartDescriptions
            .filter(d => d.dataset.chartHandle === handle)
            .pop()
            .classList.add('is-active');
    }

    addEventListeners() {
        this.chartSelectors.forEach((s) => {
            s.addEventListener('click', (e) => {
                const handle = e.target.dataset.chartHandle;

                // Switch dataset to selected portfolio
                this.changeChart(handle);

                // Add active class to selector
                s.classList.add('is-active');

                // Add active class to corresponding portfolio description
                this.updateDescription(handle);

            });
        });

        this.chartSelectorMobile.addEventListener('change', (e) => {
            const handle = e.target.value;
            this.changeChart(handle);

            // Add active class to corresponding portfolio description
            this.updateDescription(handle);
        });
    }

}

export default rootElements.map(element => new Performance(element));



// WEBPACK FOOTER //
// ./app/scripts/components/performance.js